module.exports = __webpack_public_path__ + "img/20220312_144717.f43294a2.jpg";